import {plainToInstance} from 'class-transformer';

import {EntityArray} from '../../core/entityArray';
import {CaseMetadata} from '../caseMetadata';

import {Group} from './group';

/**
 * Groups Collection
 *
 * @category Group Entity
 * */
export class Groups extends EntityArray<Group> {

  /**
   * @return first selected group in chat
   * */
  getFirstSelectedGroup() {
    return this.getByField('connectionStatus', 'ready');
  }

  /**
   * @return all selected group in chat
   * */
  getAllSelectedGroup() {
    return this.getAllByField('connectionStatus', 'ready');
  }

  /**
   * Deselect all groups
   * */
  deselectAllGroups() {
    this.getAllSelectedGroup().forEach((item) => item.unSelect())
  }

  /**
   * Get group by caseMetaData class
   *
   * @param caseMetadata - class
   *
   * @return group
   * */
  getByCase(caseMetadata: CaseMetadata) {
    return this.filter(item => !!item.caseMetadata).find(item => item.caseMetadata.serializedString === caseMetadata.serializedString);
  }

  /**
   * Get group by caseMetaData object
   *
   * @param caseMetadata - partial object
   *
   * @return group
   * */
  getByCaseObject(caseMetadata: Partial<CaseMetadata>) {
    return this.getByCase(plainToInstance(CaseMetadata, caseMetadata))
  }

}
